import { IPublishOption } from '../../../../../redux/reducers';

export function getPeriodHint(period: IPublishOption | null): string | null {
  if (period?.days === 1) {
    return 'Объявление будет размещаться бессрочно';
  }

  return null;
}
